export default {
  1: {
    Id: "rec6lSpeEbj8hwCEl",
    Quiz: 1,
    Title: "La population vaudoise",
    Question:
      "Dans le canton de Vaud, près d’une personne sur trois est de nationalité étrangère (env. 30%). Quelle est cette proportion au sein du personnel de l’Administration cantonale vaudoise (ACV) ? ",
    Media: "mp4",
    Theme: "Mirror",
    Explanation:
      "Eh oui ! Actuellement, environ une seule une personne sur dix est de nationalité étrangère au sein de l’ACV. Notons que le personnel du CHUV et des hautes écoles n’est pas compris dans cette statistique. \nL’ACV ne gagnerait-elle pas à mieux refléter la population résidente ? De quelles bonnes pratiques pourrait-on s’inspirer ? \n",
    DigAnswer: "\n",
    MoreLabel: "Pour en savoir plus",
    MoreURL:
      "https://www.vd.ch/themes/etat-droit-finances/statistique/statistiques-par-domaine/01-population/migrations",
  },
  2: {
    Id: "recZrztWx1W5MMaaj",
    Quiz: 2,
    Title: "Les langues étrangères",
    Question:
      "Après le français, quelles sont les deux langues les plus parlées au sein de la population résidant en terre vaudoise ? ",
    Media: "mp4",
    Theme: "Phylactery",
    Explanation:
      "16,5% de la population vaudoise parle anglais (9,1%) ou portugais (7,5%) à domicile. \n\nVotre équipe a peut-être déjà eu besoin de communiquer dans une ou plusieurs langues étrangères ? S’entourer d’une équipe plurilingue permet d’optimiser l’accueil et l’orientation. \n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Au moment du recrutement, vous pouvez, par exemple, ajouter à votre annonce la mention « une langue issue de la migration constitue un atout ». Vous encouragez ainsi les candidatures de personnes issues de l’immigration, sans pour autant exclure les autres. \n",
    MoreLabel: "Pour en savoir plus",
    MoreURL:
      "https://www.vd.ch/themes/etat-droit-finances/statistique/statistiques-par-domaine/01-population/langues/",
  },
  3: {
    Id: "recdWhxTYRlwzD2Si",
    Quiz: 3,
    Title: "L'accessibilité des prestations",
    Question:
      "Pour une partie de la population migrante, les démarches administratives sont compliquées avant même d’avoir commencé ! Méconnaissance de la langue, des institutions, de l’organisation administrative, de la géographie du canton ou encore des horaires spécifiques compliquent l’accès aux prestations. Comment y remédier ? En développant notamment … ",
    Media: "mp4",
    Theme: "Map",
    Explanation:
      "Les services en ligne permettent aux administré-e-s d’accéder aux prestations à tout moment, sans se déplacer. Il faudra toutefois veiller à leur offrir un soutien dans l’utilisation de ces outils numériques.\n",
    Explanation2:
      "Recourir à des personnes accompagnantes ou étendre les heures d’ouverture des guichets sont évidemment des de bonnes pistes pour faciliter l’accès à une prestation. ",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Développer des offres de prestations en ligne en mettant par exemple à disposition des usager-ères un tutoriel, une fonction aide ou la possibilité de pouvoir joindre facilement un collaborateur.\n",
  },
  4: {
    Id: "recriaDtT2TdRf7p6",
    Quiz: 4,
    Title: "Le permis F",
    Question:
      "Pour diversifier le personnel de l’ACV, une solution consiste à engager davantage de personnes détentrices de permis B (séjour), C (établissement), G (frontalier), voire L (séjour de courte durée). Mais qu’en est-il du permis F (admission provisoire) ? Est-il possible d’engager en contrat de durée indéterminée (CDI) une personne ayant ce type de permis ? ",
    Media: "mp4",
    Theme: "Permit",
    Explanation:
      "L’admission provisoire liée au permis F n’implique ni un séjour de courte durée, ni une quelconque interdiction de travailler. Le permis doit simplement être renouvelé annuellement. Cela étant peu connu, les personnes concernées peinent souvent à trouver un travail. Pourtant, les démarches sont faciles. Il suffit d’annoncer l’engagement de la personne via un formulaire en ligne. Aucune taxe n’est demandée, et l’activité peut commencer de suite. \n",
    DigQuestion: "Qu’est-ce qu’un permis F ?",
    DigAnswer:
      "Un permis F est une admission provisoire en Suisse. Les personnes concernées n’ont pas obtenu le statut de réfugié·e, mais leur renvoi est très peu probable. Ainsi, le permis F donne accès aux mêmes droits que les permis B, et est quasi systématiquement renouvelé. \n",
    MoreLabel: "Comment faire ?",
    MoreURL:
      "https://www.vd.ch/prestation/annoncer-une-activite-lucrative-pour-les-personnes-admises-provisoirement-permis-f-et-les-refugie-e-s-apatrides-permis-f-ou-b",
  },
  5: {
    Id: "recTZV2QYxYuNrqsp",
    Quiz: 5,
    Title: "Communiquer avec des personnes allophones",
    Question:
      "Avez-vous déjà vécu cette situation délicate dans laquelle vous faites face à une personne qui ne comprend visiblement pas sa situation administrative et les enjeux associés ? C’est délicat, déconcertant. Quelle solution s’offre à vous ?",
    Media: "mp4",
    Theme: "Dialog",
    Explanation:
      "Si vous avez des difficultés à communiquer avec une personne migrante et que la situation le justifie, n’hésitez pas à faire appel à une ou un interprète communautaire.\nCes professionnel·le·s maîtrisent les codes interculturels et vous apporteront bien plus qu’une simple traduction. Vous vous épargnerez des quiproquos et un temps précieux. Par ailleurs, ils·elles permettent à vos interlocuteurs·trices de s’exprimer librement et dans l’anonymat, ce qui n’est pas toujours le cas lorsqu’un·e proche se charge de la traduction.\n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Adressez-vous à votre hiérarchie pour savoir si des fonds sont disponibles pour cette prestation.\n",
    MoreLabel: "Pour en savoir plus",
    MoreURL:
      "https://www.inter-pret.ch/fr/angebote/les-services-dinterpretariat-regionaux-44.html",
    MoreURL2: "https://www.appartenances.ch/",
  },
  6: {
    Id: "recPM3FSnewmgvkZw",
    Quiz: 6,
    Title: "Les compétences langagières",
    Question:
      "Votre secrétariat a parfois des échanges téléphoniques avec des personnes qui ne maîtrisent pas le français, et qui ne comprennent pas bien les courriers que vous leur envoyez ? Savez-vous quelle est la tendance des administrations quant aux compétences langagières de leur public ?",
    Media: "mp4",
    Theme: "Mail",
    Explanation:
      "Nous avons généralement tendance à surestimer la compréhension écrite de nos interlocuteur·trices. Pourtant, qu’elles soient issues de la migration ou peu formées, les personnes qui rencontrent des difficultés à lire le français sont aussi en contact régulier avec l’ACV.\nNous vous encourageons donc à proposer à l’ensemble de votre public une communication claire, simple et si possible traduite en plusieurs langues.\n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Une première solution consiste à rédiger les textes en langage facile à lire et à comprendre (FALC) : employer des phrases courtes et des termes du langage courant. Des professionnel·les spécialisé·es dans ce domaine existent. Le BCI peut vous orienter. Pour encore plus de clarté, vous pouvez également faire traduire vos textes dans d’autres langues.\n",
    MoreLabel: "Pour en savoir plus",
    MoreURL: "https://www.langage-simplifie.ch/fr.html",
  },
  7: {
    Id: "recYPiGgCplbQY7Uk",
    Quiz: 7,
    Title: "Les propos et actes discriminatoires",
    Question:
      "« Ceux-là : tous des fainéants ! » \n« Ton papa s’appelle Mohamed, c’est sûrement ce monsieur avec la grosse barbe noire ? » \n« Les femmes de cette région sont des menteuses. »\n« Tu ferais mieux d’engager un balkanique, c’est des bosseurs ces mecs, ils ont connu la guerre ! » \n\nS’il vous est déjà arrivé d’entendre des propos discriminatoires dans le cadre de votre travail, comment avez-vous réagi ?",
    Media: "mp4",
    Theme: "Insult",
    Explanation:
      "Ne fermons pas les yeux sur les discriminations ! Ne pas réagir à des propos discriminatoires, c’est encourager la personne qui les prononce. Que vous soyez témoin direct ou secondaire d’une situation discriminatoire, nous vous encourageons à manifester votre désaccord. \n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Le BCI propose une permanence pour les victimes ainsi que les témoins de discriminations et de racisme. Les situations rapportées sont analysées pour aider au mieux les personnes impliquées. Le BCI peut les accompagner dans leurs démarches, et, selon les cas, leurs démarches juridiques.\n",
    MoreLabel: "Pour en savoir plus",
    MoreURL:
      "https://www.vd.ch/themes/population/integration-des-etrangers-et-prevention-du-racisme/situation-de-discrimination-ou-de-racisme-que-faire/",
  },
  8: {
    Id: "rec32AJ5s4YbyhEEK",
    Quiz: 8,
    Title: "Le mariage forcé",
    Question:
      "Imaginons que lors d’un entretien, une jeune femme vous confie se sentir mal dans son mariage, sans pour autant invoquer des violences. Elle reste évasive, mais la situation laisse penser qu’il pourrait s’agir d’un mariage forcé. Que faites-vous ? ",
    Media: "mp4",
    Theme: "BrokenHeart",
    Explanation:
      "Cette thématique est particulièrement sensible et complexe. Face à vos doutes et inquiétudes, il est recommandé d’activer le regard de spécialistes, voire leur intervention selon le degré d’urgence. Pour éviter de stigmatiser la personne concernée et de risquer des amalgames, nous vous conseillons vivement de contacter la permanence du BCI. \n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Prenez contact avec la permanence spécialisée du BCI. Nous offrons une consultation gratuite à toute personne confrontée personnellement ou non à une situation de mariage forcé. Il y a mariage forcé dès que l’un·e des partenaires n’a pas la possibilité de refuser l’union. La contrainte dans le mariage peut prendre des formes très variées, tant dans la manière dont elle est exercée que dans les actrices et acteurs impliqué·e·s.\n\nPour aller plus loin : Il y a mariage forcé dès que l’un·e des partenaires n’a pas la possibilité de refuser l’union. La contrainte dans le mariage peut prendre des formes très variées, tant dans la manière dont elle est exercée que dans les actrices et acteurs impliqué·es.\n",
    MoreLabel: "Pour en savoir plus ",
    MoreURL:
      "https://www.vd.ch/themes/population/integration-des-etrangers-et-prevention-du-racisme/situation-de-mariage-force-que-faire/",
  },
  9: {
    Id: "recojUqvHDhIvL1Rc",
    Quiz: 9,
    Title: "La communication interculturelle",
    Question:
      "Vous arrivez au terme d’un cheminement administratif difficile avec une famille migrante. Tous les papiers sont enfin en ordre, et vous les félicitez par le signe « parfait » (👌), réalisé avec votre pouce et votre index. La famille repart très fâchée et la confiance est rompue. Que s’est-il passé ? ",
    Media: "mp4",
    Explanation:
      "Chaque culture a ses propres codes et habitudes. Et dans certaines régions du monde, le signe « parfait » est une insulte. Élargir sa palette de compétences transculturelles aide à communiquer avec des interlocutrices et interlocuteurs venus d’ailleurs. Le BCI vous oriente, selon vos besoins, vers des formations et des partenaires adéquats.\n",
    DigQuestion: "Comment faire ?",
    DigAnswer:
      "Il existe des formations près de chez vous, dont certaines organisées par l’État de Vaud. De durées et de formats variés (jeux de rôle, séminaires, rencontres en ligne), ces cours très utiles et passionnants mettent l’accent sur les compétences transculturelles.\n",
    MoreLabel: "Se former ",
    MoreURL: "https://www.cep.vd.ch/cours/SCTN-A29LPE ",
  },
  undefined: { Id: "recnL0gKr2aLjfirF" },
};
